import { TbDoorEnter, TbDoorExit, TbFingerprint } from "react-icons/tb";
import ReceptionPhoto from "../../components/ReceptionPhoto/ReceptionPhoto";
import { Swiper, SwiperSlide } from "swiper/react";
import { SlideNextButton } from "../../components/SlideNextButton/SlideNextButton";
import { SlidePrevButton } from "../../components/SlidePrevButton/SlidePrevButton";
import { useRef, useState } from "react";
import { createDateFromFormat } from "../../utils/date";
import { formatDestinyName, isPanic } from "../Events/EventDetails/EventDetails";
import { CredentialBadge } from "../../components/CredentialBadge/CredentialBadge";
import { IoIosCloudyNight } from "react-icons/io";
import { useTranslation } from "react-i18next";
import { cn } from "../../lib/utils";

export function AccessWay({ handleClickReceptionCard, events, way, height, ...props }) {
	const { t } = useTranslation();
	const eventDetail = (way === "enter" ? "Lado externo" : "Lado interno");
	const [allowSlideNext, setAllowSlideNext] = useState(true);
	const [allowSlidePrev, setAllowSlidePrev] = useState(false);

	const swiperRef = useRef();

	function updateSwiperButtons(swiper) {
		setAllowSlideNext(!swiper.isEnd);
		setAllowSlidePrev(!swiper.isBeginning);
	}

	return (
		<div className={cn("way-column", props.className)} style={{ ...props.style }} data-way={way}>
			<h3>
				{way === 'enter' ? (
					<>
						<TbDoorEnter size={18} />
						{t("common.entry")}
					</>
				) : (
					<>
						<TbDoorExit size={18} />
						{t("common.exit")}
					</>
				)}
				<div className="swiper-button-container">
					<SlidePrevButton disabled={!allowSlidePrev} controller={swiperRef?.current?.swiper} />
					<SlideNextButton disabled={!allowSlideNext} controller={swiperRef?.current?.swiper} />
				</div>
			</h3>
			{events.filter(event => event.detail === eventDetail).length > 0 ? (
				<Swiper
					spaceBetween={8}
					slidesPerView={Math.floor(height / 90)}
					direction="vertical"
					ref={swiperRef}
					onInit={updateSwiperButtons}
					onSlideChange={updateSwiperButtons}
				>
					{events.filter(event => event.detail === eventDetail).length > 0 &&
						events.filter(event => event.detail === eventDetail).sort((eventA, eventB) => {
							if (!eventA.date || !eventB.date) return 0;
							const dateA = createDateFromFormat('d-m-Y', eventA.date);
							const dateB = createDateFromFormat('d-m-Y', eventB.date);
							return dateB.getTime() - dateA.getTime();
						}).map((event, index) => (
							<SwiperSlide key={index}>
								<div
									onClick={() => handleClickReceptionCard(event)}
									key={index}
								>
									<div className={`reception-card ${isPanic(event) ? 'is-panic-event' : ''} ${(event.result !== '1' && event.result !== 'Falha') ? '' : 'access-denied'}`}>
										<ReceptionPhoto
											smallPhoto={true}
											urlLogo={event.userData?.signed_url_photo?.replace("[:STORAGE_ADDRESS:]", window.location.hostname) || ""}
											name={event?.user || event?.name}
											subtitle={event?.target_name}
											date={`${event?.fulldate}`}
											direction={way}
											origin={formatDestinyName(way === "enter" ? event.exit_name : event.entry_name, event.userData?.unit_name)}
											destiny={formatDestinyName(way === "enter" ? event.entry_name : event.exit_name, event.userData?.unit_name)}
											onError={(e) => {
												e.target.src = "/fallback-image.png";
											}}
										/>
										<CredentialBadge event={event} />
										{isPanic(event) && (
											<span className="panic-badge">{t('common.panic')}</span>
										)}
									</div>
								</div>
							</SwiperSlide>
						))}
				</Swiper>
			) : (
				<div className="no-events-wrapper box-border! min-h-auto! h-[calc(100%-40px)]!">
					<h2 className="text-lg! leading-[1.1]!">
						{t(`monitoring.noEventTypeAtMoment`, {
							eventType: way === "enter" ? t("common.entry") : t("common.exit")
						})}
					</h2>
				</div>
			)}
		</div>
	);
}